import * as React from 'react'
import s from './styles.module.css'
// assets
import QRCodeImage from '../../../../../assets/imgs/alumni/qr-code.png'
import StraightLine from '../../../../../assets/imgs/alumni/straight-line.png'
import { motion } from 'motion/react'
import { titleAnimation } from '../../../../../constants/animation'

const QRCode = () => {
  const goToDemo = () => {
    window.open('https://app.podglobal.com/colbysawyer/alumni-map/', '_blank')
  }

  return (
    <div className={s.mobileContainer}>
      <div className={s.outerContainer}>
        <motion.p className='recruiting-main-title' variants={titleAnimation}>
          See how it works!
        </motion.p>
        <div className={s.imageContainer} onClick={goToDemo}>
          <img src={QRCodeImage} alt='qr-code' className={s.image} />

          <img
            src={StraightLine}
            className={`${s.straightLine} ${s.topLeft}`}
            alt=''
          />
          <img
            src={StraightLine}
            className={`${s.straightLine} ${s.topRight}`}
            alt=''
          />
          <img
            src={StraightLine}
            className={`${s.straightLine} ${s.centerLeft}`}
            alt=''
          />
          <img
            src={StraightLine}
            className={`${s.straightLine} ${s.centerRight}`}
            alt=''
          />
          <img
            src={StraightLine}
            className={`${s.straightLine} ${s.bottomLeft}`}
            alt=''
          />
          <img
            src={StraightLine}
            className={`${s.straightLine} ${s.bottomRight}`}
            alt=''
          />
        </div>
      </div>
    </div>
  )
}

export default QRCode
